import { render } from "./PeriodModal.vue?vue&type=template&id=220bf1ea&scoped=true"
import script from "./PeriodModal.vue?vue&type=script&lang=js"
export * from "./PeriodModal.vue?vue&type=script&lang=js"

import "./PeriodModal.vue?vue&type=style&index=0&id=220bf1ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220bf1ea"]])

export default __exports__